(ns practitest.frontend.components.notifications
  (:require ["react-toastify" :as react-toastify :refer [ToastContainer]]
            [practitest.frontend.components.icons :as icons]
            [re-frame.core :as re-frame]
            [reagent.core :as reagent]
            [goog.object :as gobj]))

(def toast-container
  (reagent/adapt-react-class ToastContainer))

(def auto-close-success-timeout 5000)

(defn- toast
  [message
   {:keys [auto-close
           draggable?
           theme
           type]
    :as   options}]
  (react-toastify/toast message #js {:autoClose    auto-close
                                     :draggable    draggable?
                                     :position     "top-center"
                                     :pauseOnHover false
                                     :theme        theme
                                     :type         type}))

(defn is-active?
  [toast-id]
  (.isActive react-toastify/toast toast-id))

(defn dismiss
  [toast-id]
  (.dismiss react-toastify/toast toast-id))

;; MouseUX-style notifications - we render most of stuff ourselves + CSS fixes
(defn- toast2
  [message
   {:keys [type
           auto-close
           id]
    :as   options}]
  (let [toast-options #js {:draggable       false
                           :position        "top-center"
                           :pauseOnHover    false
                           :theme           "mouseux"
                           :closeOnClick    false
                           :closeButton     false
                           :icon            false
                           :hideProgressBar true}
        active? (and id (is-active? id))]
    (when (some? id)
      (gobj/set toast-options "toastId" id))
    (when (some? auto-close)
      (gobj/set toast-options "autoClose" auto-close))
    (when (some? type)
      (gobj/set toast-options "type" type))

    ;; Already have this one on screen - need to update it
    ;; TODO: fix issues with hot reload (stale state ?)
    (if active?
      (do
        (gobj/set toast-options "render" message)
        (.update react-toastify/toast id toast-options))
      (react-toastify/toast message toast-options))))

(defn toast-element [body {:keys [type id raw-html? close-toast! class]}]
  (reagent/as-element
    [:div
     {:class class}
     [:div.toast-element
      {:id id}
      (case type
        "error"
        [:span.icon-notification-error
         [icons/exclamation-circle-fill]]
        "warning"
        [:span.icon-notification-warning
         [icons/exclamation-circle-fill]]
        "success"
        [:span.icon-notification-success
         [icons/mux-notification-success]]
        "info"
        [:span.icon-notification-info
         [icons/exclamation-circle-fill]]
        ;else
        nil)
      [:span.toast-text
       (if (and (string? body) raw-html?)
         {:dangerouslySetInnerHTML {:__html body}}
         body)]
      (when close-toast!
        [:span
         {:on-click (fn [e] (close-toast!))}
         [icons/mux-close]])]]))

;; MouseUX-styled notification
(defn notify!
  [body {:keys [type
                auto-close
                id
                raw-html?
                dismissible] :as options}]
  (toast2 (fn [props]
            (let [id (.-toastId props)
                  close-toast! (.-closeToast props)
                  toast-props (gobj/get props "toastProps")
                  type (gobj/get toast-props "type")]
              (toast-element body {:type type 
                                   :id id 
                                   :raw-html? raw-html? 
                                   :close-toast! (when (not= dismissible false) close-toast!)})))
          {:auto-close auto-close
           ;; Only one here
           :id id
           :type type}))

;; TODO: re-frame events ?

(re-frame/reg-fx
  ::show
  (fn [options]
    (toast (:message options)
           options)))

(re-frame/reg-event-fx
  ::success
  (fn [_ [_ message options]]
    {::show (assoc options :message message
                           :type "success")}))

(re-frame/reg-event-fx
  ::error
  (fn [_ [_ message options]]
    {::show (assoc options :message message
                           :type "error")}))

(re-frame/reg-fx
  ::show2
  (fn [options]
    (notify! (:message options)
             options)))

(re-frame/reg-event-fx
  ::success2
  (fn [_ [_ message options]]
    {::show2 (assoc options :message message
                            :type "success")}))

(re-frame/reg-event-fx
  ::error2
  (fn [_ [_ message options]]
    {::show2 (assoc options :message message
                            :type "error")}))

(re-frame/reg-event-fx
  ::warning2
  (fn [_ [_ message options]]
    {::show2 (assoc options :message message
                            :type "warning")}))
